import { render } from "./AnswersMobileResult.vue?vue&type=template&id=24512eed&scoped=true"
import script from "./AnswersMobileResult.vue?vue&type=script&lang=js"
export * from "./AnswersMobileResult.vue?vue&type=script&lang=js"

import "./AnswersMobileResult.vue?vue&type=style&index=0&id=24512eed&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Anael\\Documents\\developpement\\teachup-video-interactive\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24512eed"]])

export default __exports__